import React from 'react';

// Dashboard Icon
export const DashboardIcon = ({ className, style, ...props }) => (
  <svg 
    width="30" 
    height="30" 
    viewBox="0 -0.5 25 25" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...props}
  >
    <path 
      d="M9.5 5.75C9.91421 5.75 10.25 5.41421 10.25 5C10.25 4.58579 9.91421 4.25 9.5 4.25V5.75ZM4.75 11C4.75 11.4142 5.08579 11.75 5.5 11.75C5.91421 11.75 6.25 11.4142 6.25 11H4.75ZM9.5 4.25C9.08579 4.25 8.75 4.58579 8.75 5C8.75 5.41421 9.08579 5.75 9.5 5.75V4.25ZM18.75 11C18.75 11.4142 19.0858 11.75 19.5 11.75C19.9142 11.75 20.25 11.4142 20.25 11H18.75ZM10.25 5C10.25 4.58579 9.91421 4.25 9.5 4.25C9.08579 4.25 8.75 4.58579 8.75 5H10.25ZM8.75 11C8.75 11.4142 9.08579 11.75 9.5 11.75C9.91421 11.75 10.25 11.4142 10.25 11H8.75ZM9.5 11.75C9.91421 11.75 10.25 11.4142 10.25 11C10.25 10.5858 9.91421 10.25 9.5 10.25V11.75ZM5.5 10.25C5.08579 10.25 4.75 10.5858 4.75 11C4.75 11.4142 5.08579 11.75 5.5 11.75V10.25ZM9.5 10.25C9.08579 10.25 8.75 10.5858 8.75 11C8.75 11.4142 9.08579 11.75 9.5 11.75V10.25ZM19.5 11.75C19.9142 11.75 20.25 11.4142 20.25 11C20.25 10.5858 19.9142 10.25 19.5 10.25V11.75ZM6.25 11C6.25 10.5858 5.91421 10.25 5.5 10.25C5.08579 10.25 4.75 10.5858 4.75 11H6.25ZM20.25 11C20.25 10.5858 19.9142 10.25 19.5 10.25C19.0858 10.25 18.75 10.5858 18.75 11H20.25ZM9.5 4.25C6.87665 4.25 4.75 6.37665 4.75 9H6.25C6.25 7.20507 7.70507 5.75 9.5 5.75V4.25ZM4.75 9V11H6.25V9H4.75ZM9.5 5.75H15.5V4.25H9.5V5.75ZM15.5 5.75C17.2949 5.75 18.75 7.20507 18.75 9H20.25C20.25 6.37665 18.1234 4.25 15.5 4.25V5.75ZM18.75 9V11H20.25V9H18.75ZM8.75 5V11H10.25V5H8.75ZM9.5 10.25H5.5V11.75H9.5V10.25ZM9.5 11.75H19.5V10.25H9.5V11.75ZM4.75 11V15H6.25V11H4.75ZM4.75 15C4.75 17.6234 6.87665 19.75 9.5 19.75V18.25C7.70507 18.25 6.25 16.7949 6.25 15H4.75ZM9.5 19.75H15.5V18.25H9.5V19.75ZM15.5 19.75C18.1234 19.75 20.25 17.6234 20.25 15H18.75C18.75 16.7949 17.2949 18.25 15.5 18.25V19.75ZM20.25 15V11H18.75V15H20.25Z" 
      fill="currentColor"
    />
  </svg>
);

// Calendar Icon
export const CalendarIcon = ({ className, style, ...props }) => (
  <svg 
    width="30" 
    height="30" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...props}
  >
    <path 
      d="M8.77502 6.75C9.18924 6.75 9.52502 6.41421 9.52502 6C9.52502 5.58579 9.18924 5.25 8.77502 5.25V6.75ZM14.625 5.25C14.2108 5.25 13.875 5.58579 13.875 6C13.875 6.41421 14.2108 6.75 14.625 6.75V5.25ZM8.77502 5.25C8.36081 5.25 8.02502 5.58579 8.02502 6C8.02502 6.41421 8.36081 6.75 8.77502 6.75V5.25ZM14.625 6.75C15.0392 6.75 15.375 6.41421 15.375 6C15.375 5.58579 15.0392 5.25 14.625 5.25V6.75ZM9.52502 6C9.52502 5.58579 9.18924 5.25 8.77502 5.25C8.36081 5.25 8.02502 5.58579 8.02502 6H9.52502ZM8.02502 7C8.02502 7.41421 8.36081 7.75 8.77502 7.75C9.18924 7.75 9.52502 7.41421 9.52502 7H8.02502ZM8.02502 6C8.02502 6.41421 8.36081 6.75 8.77502 6.75C9.18924 6.75 9.52502 6.41421 9.52502 6H8.02502ZM9.52502 4C9.52502 3.58579 9.18924 3.25 8.77502 3.25C8.36081 3.25 8.02502 3.58579 8.02502 4H9.52502ZM15.375 6C15.375 5.58579 15.0392 5.25 14.625 5.25C14.2108 5.25 13.875 5.58579 13.875 6H15.375ZM13.875 7C13.875 7.41421 14.2108 7.75 14.625 7.75C15.0392 7.75 15.375 7.41421 15.375 7H13.875ZM13.875 6C13.875 6.41421 14.2108 6.75 14.625 6.75C15.0392 6.75 15.375 6.41421 15.375 6H13.875ZM15.375 4C15.375 3.58579 15.0392 3.25 14.625 3.25C14.2108 3.25 13.875 3.58579 13.875 4H15.375ZM8.77502 5.25C6.18911 5.25 4.12502 7.39466 4.12502 10H5.62502C5.62502 8.18706 7.05311 6.75 8.77502 6.75V5.25ZM4.12502 10V16H5.62502V10H4.12502ZM4.12502 16C4.12502 18.6053 6.18911 20.75 8.77502 20.75V19.25C7.05311 19.25 5.62502 17.8129 5.62502 16H4.12502ZM8.77502 20.75H14.625V19.25H8.77502V20.75ZM14.625 20.75C17.2109 20.75 19.275 18.6053 19.275 16H17.775C17.775 17.8129 16.3469 19.25 14.625 19.25V20.75ZM19.275 16V10H17.775V16H19.275ZM19.275 10C19.275 7.39466 17.2109 5.25 14.625 5.25V6.75C16.3469 6.75 17.775 8.18706 17.775 10H19.275ZM8.77502 6.75H14.625V5.25L8.77502 5.25V6.75ZM8.02502 6V7H9.52502V6H8.02502ZM9.52502 6V4H8.02502V6H9.52502ZM13.875 6V7H15.375V6H13.875ZM15.375 6V4H13.875V6H15.375Z" 
      fill="currentColor"
    />
    <path 
      d="M7.79999 13L9.74999 16L15.6 11" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Live Monitor Icon
export const LiveMonitorIcon = ({ className, style, ...props }) => (
  <svg 
    width="30" 
    height="30" 
    viewBox="0 -0.5 25 25" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...props}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M15.1921 5H9.80807C8.65914 5.00635 7.5598 5.46885 6.75189 6.28576C5.94398 7.10268 5.49368 8.20708 5.50007 9.356V14.644C5.49368 15.7929 5.94398 16.8973 6.75189 17.7142C7.5598 18.5311 8.65914 18.9937 9.80807 19H15.1921C16.341 18.9937 17.4403 18.5311 18.2482 17.7142C19.0562 16.8973 19.5064 15.7929 19.5001 14.644V9.356C19.5064 8.20708 19.0562 7.10268 18.2482 6.28576C17.4403 5.46885 16.341 5.00635 15.1921 5Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M10.0001 13L12.5001 8V11H15.0001L12.5001 16V13H10.0001Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Sync Management Icon
export const SyncManagementIcon = ({ className, style, ...props }) => (
  <svg 
    width="30" 
    height="30" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...props}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M10 11.0006C10 10.4483 10.4477 10.0006 11 10.0006H13C13.5523 10.0006 14 10.4483 14 11.0006V13.0006C14 13.5529 13.5523 14.0006 13 14.0006H11C10.4477 14.0006 10 13.5529 10 13.0006V11.0006Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M4.25 12.0014C4.25042 12.4156 4.58654 12.751 5.00075 12.7506C5.41497 12.7502 5.75042 12.4141 5.75 11.9999L4.25 12.0014ZM6.144 8.1116L6.77414 8.51834L6.77451 8.51777L6.144 8.1116ZM9.19 5.5336L8.89458 4.84424L8.89364 4.84464L9.19 5.5336ZM13.111 5.1336L13.2635 4.39927L13.2611 4.39878L13.111 5.1336ZM16.585 7.0506L16.0451 7.57114L16.0456 7.57175L16.585 7.0506ZM18.29 10.0006L17.5692 10.2078C17.6626 10.5326 17.9617 10.7549 18.2996 10.7505C18.6376 10.7462 18.9309 10.5164 19.0159 10.1892L18.29 10.0006ZM19.7259 7.45725C19.8301 7.05635 19.5895 6.6469 19.1886 6.54271C18.7878 6.43853 18.3783 6.67906 18.2741 7.07996L19.7259 7.45725ZM19.75 11.9999C19.7496 11.5856 19.4135 11.2502 18.9993 11.2506C18.585 11.251 18.2496 11.5871 18.25 12.0014L19.75 11.9999ZM17.856 15.8896L17.2259 15.4829L17.2255 15.4834L17.856 15.8896ZM14.81 18.4676L15.1054 19.157L15.1064 19.1566L14.81 18.4676ZM10.889 18.8676L10.7365 19.6019L10.7389 19.6024L10.889 18.8676ZM7.415 16.9506L7.95495 16.4301L7.95436 16.4295L7.415 16.9506ZM5.71 14.0006L6.43082 13.7934C6.33745 13.4686 6.03835 13.2463 5.70039 13.2507C5.36244 13.255 5.06913 13.4848 4.98412 13.812L5.71 14.0006ZM4.27412 16.544C4.16993 16.9449 4.41046 17.3543 4.81136 17.4585C5.21225 17.5627 5.6217 17.3221 5.72589 16.9212L4.27412 16.544ZM5.75 11.9999C5.74877 10.7649 6.10441 9.55591 6.77414 8.51834L5.51387 7.70487C4.68737 8.98532 4.24848 10.4773 4.25 12.0014L5.75 11.9999ZM6.77451 8.51777C7.43011 7.50005 8.37429 6.70094 9.48637 6.22256L8.89364 4.84464C7.50751 5.4409 6.33066 6.43693 5.5135 7.70544L6.77451 8.51777ZM9.48543 6.22297C10.5808 5.75356 11.7933 5.62986 12.9609 5.86842L13.2611 4.39878C11.7942 4.09906 10.2708 4.25448 8.89458 4.84424L9.48543 6.22297ZM12.9585 5.86793C14.1352 6.11232 15.2109 6.7059 16.0451 7.57114L17.1249 6.53006C16.0814 5.44761 14.7357 4.70502 13.2635 4.39927L12.9585 5.86793ZM16.0456 7.57175C16.7615 8.31258 17.2846 9.21772 17.5692 10.2078L19.0108 9.79342C18.6585 8.5675 18.0107 7.44675 17.1244 6.52945L16.0456 7.57175ZM19.0159 10.1892L19.7259 7.45725L18.2741 7.07996L17.5641 9.81196L19.0159 10.1892ZM18.25 12.0014C18.2512 13.2363 17.8956 14.4453 17.2259 15.4829L18.4861 16.2963C19.3126 15.0159 19.7515 13.5239 19.75 11.9999L18.25 12.0014ZM17.2255 15.4834C16.5699 16.5012 15.6257 17.3003 14.5136 17.7786L15.1064 19.1566C16.4925 18.5603 17.6693 17.5643 18.4865 16.2958L17.2255 15.4834ZM14.5146 17.7782C13.4193 18.2476 12.2067 18.3713 11.0391 18.1328L10.7389 19.6024C12.2058 19.9021 13.7293 19.7467 15.1054 19.157L14.5146 17.7782ZM11.0415 18.1333C9.86478 17.8889 8.78909 17.2953 7.95495 16.4301L6.87506 17.4711C7.91861 18.5536 9.26434 19.2962 10.7365 19.6019L11.0415 18.1333ZM7.95436 16.4295C7.23854 15.6886 6.7154 14.7835 6.43082 13.7934L4.98919 14.2078C5.34156 15.4337 5.98931 16.5545 6.87565 17.4718L7.95436 16.4295ZM4.98412 13.812L4.27412 16.544L5.72589 16.9212L6.43589 14.1892L4.98412 13.812Z" 
      fill="currentColor"
    />
  </svg>
);

// Courses Icon
export const CoursesIcon = ({ className, style, ...props }) => (
  <svg 
    width="30" 
    height="30" 
    viewBox="0 -0.5 25 25" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...props}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M8.24945 17.3586C7.59135 17.472 6.91604 17.3005 6.39185 16.8868C5.86766 16.473 5.54396 15.856 5.50145 15.1896V8.02759C5.47083 7.27605 5.92795 6.59038 6.63345 6.32959C8.7056 5.56915 11.032 6.15154 12.5014 7.79859V18.0196C11.5164 17.1916 9.81445 17.1416 8.24945 17.3586Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M16.7534 17.3586C17.4115 17.472 18.0869 17.3005 18.611 16.8868C19.1352 16.473 19.4589 15.856 19.5014 15.1896V8.02759C19.5321 7.27605 19.075 6.59038 18.3694 6.32959C16.2973 5.56915 13.9709 6.15154 12.5014 7.79859V18.0196C13.4864 17.1916 15.1884 17.1416 16.7534 17.3586Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M10.0014 11.7695C10.4157 11.7695 10.7514 11.4337 10.7514 11.0195C10.7514 10.6053 10.4157 10.2695 10.0014 10.2695V11.7695ZM8.00145 10.2695C7.58724 10.2695 7.25145 10.6053 7.25145 11.0195C7.25145 11.4337 7.58724 11.7695 8.00145 11.7695V10.2695ZM10.0014 13.7695C10.4157 13.7695 10.7514 13.4337 10.7514 13.0195C10.7514 12.6053 10.4157 12.2695 10.0014 12.2695V13.7695ZM8.00145 12.2695C7.58724 12.2695 7.25145 12.6053 7.25145 13.0195C7.25145 13.4337 7.58724 13.7695 8.00145 13.7695V12.2695ZM17.0014 11.7695C17.4157 11.7695 17.7514 11.4337 17.7514 11.0195C17.7514 10.6053 17.4157 10.2695 17.0014 10.2695V11.7695ZM15.0014 10.2695C14.5872 10.2695 14.2514 10.6053 14.2514 11.0195C14.2514 11.4337 14.5872 11.7695 15.0014 11.7695V10.2695ZM17.0014 13.7695C17.4157 13.7695 17.7514 13.4337 17.7514 13.0195C17.7514 12.6053 17.4157 12.2695 17.0014 12.2695V13.7695ZM15.0014 12.2695C14.5872 12.2695 14.2514 12.6053 14.2514 13.0195C14.2514 13.4337 14.5872 13.7695 15.0014 13.7695V12.2695ZM10.0014 10.2695H8.00145V11.7695H10.0014V10.2695ZM10.0014 12.2695H8.00145V13.7695H10.0014V12.2695ZM17.0014 10.2695H15.0014V11.7695H17.0014V10.2695ZM17.0014 12.2695H15.0014V13.7695H17.0014V12.2695Z" 
      fill="currentColor"
    />
  </svg>
);

// Groups Icon
export const GroupsIcon = ({ className, style, ...props }) => (
  <svg 
    width="30" 
    height="30" 
    viewBox="0 -0.5 25 25" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...props}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M14.9238 7.281C14.9227 8.5394 13.9018 9.55874 12.6435 9.558C11.3851 9.55726 10.3654 8.53673 10.3658 7.27833C10.3662 6.01994 11.3864 5 12.6448 5C13.2495 5.00027 13.8293 5.24073 14.2567 5.6685C14.6841 6.09627 14.924 6.67631 14.9238 7.281Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M14.9968 12.919H10.2968C8.65471 12.9706 7.35028 14.3166 7.35028 15.9595C7.35028 17.6024 8.65471 18.9484 10.2968 19H14.9968C16.6388 18.9484 17.9432 17.6024 17.9432 15.9595C17.9432 14.3166 16.6388 12.9706 14.9968 12.919V12.919Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M20.6878 9.02403C20.6872 9.98653 19.9066 10.7664 18.9441 10.766C17.9816 10.7657 17.2016 9.9852 17.2018 9.0227C17.202 8.06019 17.9823 7.28003 18.9448 7.28003C19.4072 7.28003 19.8507 7.4638 20.1776 7.7909C20.5045 8.11799 20.688 8.56158 20.6878 9.02403V9.02403Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M4.3338 9.02401C4.3338 9.98664 5.11417 10.767 6.0768 10.767C7.03943 10.767 7.8198 9.98664 7.8198 9.02401C7.8198 8.06137 7.03943 7.28101 6.0768 7.28101C5.11417 7.28101 4.3338 8.06137 4.3338 9.02401V9.02401Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M19.4368 12.839C19.0226 12.839 18.6868 13.1748 18.6868 13.589C18.6868 14.0032 19.0226 14.339 19.4368 14.339V12.839ZM20.7438 13.589L20.7593 12.8392C20.7541 12.839 20.749 12.839 20.7438 12.839V13.589ZM20.7438 18.24V18.99C20.749 18.99 20.7541 18.9899 20.7593 18.9898L20.7438 18.24ZM19.4368 17.49C19.0226 17.49 18.6868 17.8258 18.6868 18.24C18.6868 18.6542 19.0226 18.99 19.4368 18.99V17.49ZM5.58477 14.339C5.99899 14.339 6.33477 14.0032 6.33477 13.589C6.33477 13.1748 5.99899 12.839 5.58477 12.839V14.339ZM4.27777 13.589V12.839C4.27259 12.839 4.26741 12.839 4.26222 12.8392L4.27777 13.589ZM4.27777 18.24L4.26222 18.9898C4.26741 18.9899 4.27259 18.99 4.27777 18.99V18.24ZM5.58477 18.99C5.99899 18.99 6.33477 18.6542 6.33477 18.24C6.33477 17.8258 5.99899 17.49 5.58477 17.49V18.99ZM19.4368 14.339H20.7438V12.839H19.4368V14.339ZM20.7282 14.3388C21.5857 14.3566 22.2715 15.0568 22.2715 15.9145H23.7715C23.7715 14.2405 22.4329 12.8739 20.7593 12.8392L20.7282 14.3388ZM22.2715 15.9145C22.2715 16.7722 21.5857 17.4724 20.7282 17.4902L20.7593 18.9898C22.4329 18.9551 23.7715 17.5885 23.7715 15.9145H22.2715ZM20.7438 17.49H19.4368V18.99H20.7438V17.49ZM5.58477 12.839H4.27777V14.339H5.58477V12.839ZM4.26222 12.8392C2.58861 12.8739 1.25 14.2405 1.25 15.9145H2.75C2.75 15.0568 3.43584 14.3566 4.29332 14.3388L4.26222 12.8392ZM1.25 15.9145C1.25 17.5885 2.58861 18.9551 4.26222 18.9898L4.29332 17.4902C3.43584 17.4724 2.75 16.7722 2.75 15.9145H1.25ZM4.27777 18.99H5.58477V17.49H4.27777V18.99Z" 
      fill="currentColor"
    />
  </svg>
);

// Students Icon
export const StudentsIcon = ({ className, style, ...props }) => (
  <svg 
    width="30" 
    height="30" 
    viewBox="0 -0.5 25 25" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...props}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M12.5 7.333C12.5 8.62148 11.4555 9.666 10.167 9.666C8.8785 9.666 7.83398 8.62148 7.83398 7.333C7.83398 6.04452 8.8785 5 10.167 5C11.4555 5 12.5 6.04452 12.5 7.333Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M14.833 15.733C14.833 17.533 12.744 19 10.166 19C7.588 19 5.5 17.537 5.5 15.733C5.5 13.929 7.589 12.467 10.167 12.467C12.745 12.467 14.833 13.929 14.833 15.733Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M17.439 9.51102C17.439 10.2842 16.8122 10.911 16.039 10.911C15.2658 10.911 14.639 10.2842 14.639 9.51102C14.639 8.73782 15.2658 8.11102 16.039 8.11102C16.4103 8.11102 16.7664 8.25852 17.0289 8.52107C17.2915 8.78362 17.439 9.13972 17.439 9.51102Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M16.7 18.067C18.1138 18.1831 19.3596 17.1445 19.5 15.733C19.3591 14.3218 18.1134 13.2839 16.7 13.4" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Settings Icon
export const SettingsIcon = ({ className, style, ...props }) => (
  <svg 
    width="30" 
    height="30" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...props}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M11.0175 19C10.6601 19 10.3552 18.7347 10.297 18.373C10.2434 18.0804 10.038 17.8413 9.76171 17.75C9.53658 17.6707 9.31645 17.5772 9.10261 17.47C8.84815 17.3365 8.54289 17.3565 8.30701 17.522C8.02156 17.7325 7.62943 17.6999 7.38076 17.445L6.41356 16.453C6.15326 16.186 6.11944 15.7651 6.33361 15.458C6.49878 15.2105 6.52257 14.8914 6.39601 14.621C6.31262 14.4332 6.23906 14.2409 6.17566 14.045C6.08485 13.7363 5.8342 13.5051 5.52533 13.445C5.15287 13.384 4.8779 13.0559 4.87501 12.669V11.428C4.87303 10.9821 5.18705 10.6007 5.61601 10.528C5.94143 10.4645 6.21316 10.2359 6.33751 9.921C6.37456 9.83233 6.41356 9.74433 6.45451 9.657C6.61989 9.33044 6.59705 8.93711 6.39503 8.633C6.1424 8.27288 6.18119 7.77809 6.48668 7.464L7.19746 6.735C7.54802 6.37532 8.1009 6.32877 8.50396 6.625L8.52638 6.641C8.82735 6.84876 9.21033 6.88639 9.54428 6.741C9.90155 6.60911 10.1649 6.29424 10.2375 5.912L10.2473 5.878C10.3275 5.37197 10.7536 5.00021 11.2535 5H12.1115C12.6248 4.99976 13.0629 5.38057 13.1469 5.9L13.1625 5.97C13.2314 6.33617 13.4811 6.63922 13.8216 6.77C14.1498 6.91447 14.5272 6.87674 14.822 6.67L14.8707 6.634C15.2842 6.32834 15.8528 6.37535 16.2133 6.745L16.8675 7.417C17.1954 7.75516 17.2366 8.28693 16.965 8.674C16.7522 8.99752 16.7251 9.41325 16.8938 9.763L16.9358 9.863C17.0724 10.2045 17.3681 10.452 17.7216 10.521C18.1837 10.5983 18.5235 11.0069 18.525 11.487V12.6C18.5249 13.0234 18.2263 13.3846 17.8191 13.454C17.4842 13.5199 17.2114 13.7686 17.1083 14.102C17.0628 14.2353 17.0121 14.3687 16.9562 14.502C16.8261 14.795 16.855 15.1364 17.0323 15.402C17.2662 15.7358 17.2299 16.1943 16.9465 16.485L16.0388 17.417C15.7792 17.6832 15.3698 17.7175 15.0716 17.498C14.8226 17.3235 14.5001 17.3043 14.2331 17.448C14.0428 17.5447 13.8475 17.6305 13.6481 17.705C13.3692 17.8037 13.1636 18.0485 13.1099 18.346C13.053 18.7203 12.7401 18.9972 12.3708 19H11.0175Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M13.9747 12C13.9747 13.2885 12.9563 14.333 11.7 14.333C10.4437 14.333 9.42533 13.2885 9.42533 12C9.42533 10.7115 10.4437 9.66699 11.7 9.66699C12.9563 9.66699 13.9747 10.7115 13.9747 12Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Users Icon
export const UsersIcon = ({ className, style, ...props }) => (
  <svg 
    width="30" 
    height="30" 
    viewBox="0 -0.5 25 25" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...props}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M15.5 8C15.5 9.65685 14.1569 11 12.5 11C10.8431 11 9.5 9.65685 9.5 8C9.5 6.34315 10.8431 5 12.5 5C13.2956 5 14.0587 5.31607 14.6213 5.87868C15.1839 6.44129 15.5 7.20435 15.5 8Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M16 14H9C7.61929 14 6.5 15.1193 6.5 16.5C6.5 17.8807 7.61929 19 9 19H16C17.3807 19 18.5 17.8807 18.5 16.5C18.5 15.1193 17.3807 14 16 14V14Z" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Tick/Checkmark Icon for Assign Button
export const TickIcon = ({ className, style, ...props }) => (
  <svg 
    width="2.28em" 
    height="2.28em" 
    viewBox="0 -0.5 25 25" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...props}
  >
    <path 
      d="M5.5 12.5L10.167 17L19.5 8" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Lock/Unlock Icon for Student Credentials
export const LockUnlockIcon = ({ className, style, ...props }) => (
  <svg 
    width="1em" 
    height="1em" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ color: '#000000', ...style }}
    {...props}
  >
    <path 
      d="M9.34568 15.5C9.34568 15.9142 9.68147 16.25 10.0957 16.25C10.5099 16.25 10.8457 15.9142 10.8457 15.5H9.34568ZM10.8457 13.75C10.8457 13.3358 10.5099 13 10.0957 13C9.68147 13 9.34568 13.3358 9.34568 13.75H10.8457ZM12.1556 8.61C12.1556 9.02421 12.4914 9.36 12.9056 9.36C13.3198 9.36 13.6556 9.02421 13.6556 8.61H12.1556ZM12.9056 8.15H13.6556C13.6556 8.13967 13.6554 8.12933 13.655 8.11901L12.9056 8.15ZM15.7166 5L15.7522 4.25085C15.7285 4.24972 15.7048 4.24972 15.6811 4.25084L15.7166 5ZM18.5265 8.15L17.7772 8.119C17.7767 8.12932 17.7765 8.13966 17.7765 8.15H18.5265ZM17.7765 8.61C17.7765 9.02421 18.1123 9.36 18.5265 9.36C18.9407 9.36 19.2765 9.02421 19.2765 8.61H17.7765ZM12.9056 8.61L13.1265 7.89325C13.1203 7.89134 13.1141 7.88951 13.1078 7.88777L12.9056 8.61ZM12.1022 8.5L12.1022 9.25L12.103 9.25L12.1022 8.5ZM8.08816 8.5L8.08736 9.25H8.08816V8.5ZM7.28476 8.61L7.08257 7.88777C7.07626 7.88954 7.06996 7.89139 7.0637 7.89332L7.28476 8.61ZM4.87651 12L5.62664 12L5.62638 11.9859L4.87651 12ZM4.87651 15.5L5.62619 15.5219C5.6264 15.5146 5.62651 15.5073 5.62651 15.5H4.87651ZM8.08816 19L8.06452 19.7496C8.0724 19.7499 8.08028 19.75 8.08816 19.75V19ZM12.1032 19V19.75C12.1111 19.75 12.119 19.7499 12.1268 19.7496L12.1032 19ZM15.3149 15.5H14.5649C14.5649 15.5073 14.565 15.5146 14.5652 15.5219L15.3149 15.5ZM15.3149 12L14.5649 11.9859V12H15.3149ZM10.8457 15.5V13.75H9.34568V15.5H10.8457ZM13.6556 8.61V8.15H12.1556V8.61H13.6556ZM13.655 8.11901C13.6024 6.84853 14.5586 5.80558 15.752 5.74916L15.6811 4.25084C13.6286 4.34787 12.0711 6.12179 12.1563 8.18099L13.655 8.11901ZM15.6809 5.74915C16.874 5.80596 17.8297 6.84881 17.7772 8.119L19.2759 8.181C19.361 6.12226 17.8043 4.34855 15.7522 4.25085L15.6809 5.74915ZM17.7765 8.15V8.61H19.2765V8.15H17.7765ZM13.1078 7.88777C12.7801 7.79601 12.4416 7.74964 12.1014 7.75L12.103 9.25C12.3057 9.24978 12.5076 9.2774 12.7034 9.33223L13.1078 7.88777ZM12.1022 7.75H8.08816V9.25H12.1022V7.75ZM8.08896 7.75C7.74883 7.74964 7.41033 7.79601 7.08257 7.88777L7.48695 9.33223C7.6828 9.2774 7.88471 9.24978 8.08736 9.25L8.08896 7.75ZM7.0637 7.89332C5.28076 8.44327 4.09125 10.1348 4.12664 12.0141L5.62638 11.9859C5.60316 10.7531 6.38248 9.67318 7.50582 9.32668L7.0637 7.89332ZM4.12651 12V15.5H5.62651V12H4.12651ZM4.12683 15.4781C4.06062 17.7494 5.80466 19.6784 8.06452 19.7496L8.1118 18.2504C6.71393 18.2063 5.58304 17.0022 5.62619 15.5219L4.12683 15.4781ZM8.08816 19.75H12.1032V18.25H8.08816V19.75ZM12.1268 19.7496C14.3867 19.6784 16.1307 17.7494 16.0645 15.4781L14.5652 15.5219C14.6083 17.0022 13.4774 18.2063 12.0796 18.2504L12.1268 19.7496ZM16.0649 15.5V12H14.5649V15.5H16.0649ZM16.0647 12.0141C16.1 10.1344 14.9099 8.44275 13.1265 7.89325L12.6848 9.32675C13.8084 9.67296 14.5881 10.7529 14.565 11.9859L16.0647 12.0141Z" 
      fill="currentColor"
    />
  </svg>
);

// Share Icon for Student Copy Link
export const ShareIcon = ({ className, style, ...props }) => (
  <svg 
    width="1em" 
    height="1em" 
    viewBox="0 -0.5 25 25" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ color: '#000000', ...style }}
    {...props}
  >
    <path 
      d="M12.5 6.25C12.9142 6.25 13.25 5.91421 13.25 5.5C13.25 5.08579 12.9142 4.75 12.5 4.75V6.25ZM20.25 12.5C20.25 12.0858 19.9142 11.75 19.5 11.75C19.0858 11.75 18.75 12.0858 18.75 12.5H20.25ZM19.5 6.25C19.9142 6.25 20.25 5.91421 20.25 5.5C20.25 5.08579 19.9142 4.75 19.5 4.75V6.25ZM15.412 4.75C14.9978 4.75 14.662 5.08579 14.662 5.5C14.662 5.91421 14.9978 6.25 15.412 6.25V4.75ZM20.25 5.5C20.25 5.08579 19.9142 4.75 19.5 4.75C19.0858 4.75 18.75 5.08579 18.75 5.5H20.25ZM18.75 9.641C18.75 10.0552 19.0858 10.391 19.5 10.391C19.9142 10.391 20.25 10.0552 20.25 9.641H18.75ZM20.0303 6.03033C20.3232 5.73744 20.3232 5.26256 20.0303 4.96967C19.7374 4.67678 19.2626 4.67678 18.9697 4.96967L20.0303 6.03033ZM11.9697 11.9697C11.6768 12.2626 11.6768 12.7374 11.9697 13.0303C12.2626 13.3232 12.7374 13.3232 13.0303 13.0303L11.9697 11.9697ZM12.5 4.75H9.5V6.25H12.5V4.75ZM9.5 4.75C6.87665 4.75 4.75 6.87665 4.75 9.5H6.25C6.25 7.70507 7.70507 6.25 9.5 6.25V4.75ZM4.75 9.5V15.5H6.25V9.5H4.75ZM4.75 15.5C4.75 18.1234 6.87665 20.25 9.5 20.25V18.75C7.70507 18.75 6.25 17.2949 6.25 15.5H4.75ZM9.5 20.25H15.5V18.75H9.5V20.25ZM15.5 20.25C18.1234 20.25 20.25 18.1234 20.25 15.5H18.75C18.75 17.2949 17.2949 18.75 15.5 18.75V20.25ZM20.25 15.5V12.5H18.75V15.5H20.25ZM19.5 4.75H15.412V6.25H19.5V4.75ZM18.75 5.5V9.641H20.25V5.5H18.75ZM18.9697 4.96967L11.9697 11.9697L13.0303 13.0303L20.0303 6.03033L18.9697 4.96967Z" 
      fill="#000000"
    />
  </svg>
);